import api from '@/api'
import vuex from '@/store'

export default {
  state: {
    storyTags: [],
    videoTags: [],
    employees: [],
    format: [],
    platforms: [],
    region: [],
    status: [],
    pillar: [
      { value: 'Realtime', label: 'Realtime' },
      { value: 'The Signature Issue', label: 'The Signature Issue' },
      { value: 'Enterprise', label: 'Enterprise' },
      { value: 'Investigative', label: 'Investigative' },
      { value: 'Community Connection', label: 'Community Connection' },
      { value: 'Differentiator', label: 'Differentiator' },
      { value: 'N/A', label: 'N/A' }
    ],
    storyApproved: [{ value: 'Approved' }, { value: 'Info Only' }, { value: 'Scheduling' }, { value: 'Idea' }, { value: 'Bust' }],
    storyType: [],
    liveType: [],
    liveSource: [],
    notificationGroupsList: []
  },
  mutations: {
    LOAD_OPTION_TYPE(state, { type, data }) {
      state[type] = data
    },
    CLEAR_ALL_OPTIONS(state) {
      console.debug('CLEARING ALL OPTIONS')
      state.storyTags = []
      state.videoTags = []
      state.employees = []
      state.format = []
      state.platforms = []
      state.region = []
      state.status = []
      state.storyType = []
      state.liveType = []
      state.liveSource = []
      state.notificationGroupsList = []
    },

    UPSERT_EMPLOYEE(state, data) {
      let idx = state.employees.findIndex((emp) => emp.value == data.value)
      if (idx < 0) {
        state.employees.push(data)
      } else {
        // use vue set so its reactive
        state.employees[idx] = Object.assign(state.employees[idx], data)
      }
    },
    DELETE_EMPLOYEE(state, id) {
      let idx = state.employees.findIndex((emp) => emp.value == id)
      if (idx >= 0) {
        state.employees.splice(idx, 1)
      }
    }
  },
  actions: {
    async loadOptionType({ commit, state, dispatch }, { type, skipCache = false } = {}) {
      // get list of stories from API
      const _o = await api.newsdesk.getColumnOptions(type, skipCache)
      let requests = _o?.data ?? []

      commit('LOAD_OPTION_TYPE', { type, data: requests })
    },
    async loadAllOptionTypes({ commit, state, dispatch }, { skipCache = false } = {}) {
      const _o = await api.newsdesk.getAllColumnOptions(skipCache)
      let options = _o?.data ?? []

      commit('LOAD_OPTION_TYPE', { type: 'storyTags', data: options.filter((o) => o.column == 'storyTags') })
      commit('LOAD_OPTION_TYPE', { type: 'videoTags', data: options.filter((o) => o.column == 'videoTags') })
      commit('LOAD_OPTION_TYPE', { type: 'storyType', data: options.filter((o) => o.column == 'storyType') })
      commit('LOAD_OPTION_TYPE', { type: 'format', data: options.filter((o) => o.column == 'format') })
      commit('LOAD_OPTION_TYPE', { type: 'platforms', data: options.filter((o) => o.column == 'platforms') })
      commit('LOAD_OPTION_TYPE', { type: 'region', data: options.filter((o) => o.column == 'region') })
      commit('LOAD_OPTION_TYPE', { type: 'status', data: options.filter((o) => o.column == 'status') })
      commit('LOAD_OPTION_TYPE', { type: 'liveType', data: options.filter((o) => o.column == 'liveType') })
      commit('LOAD_OPTION_TYPE', { type: 'liveSource', data: options.filter((o) => o.column == 'liveSource') })
    },
    async loadEmployees({ commit, state, dispatch }, { skipCache = false } = {}) {
      let employees = []
      try {
        // Set a longer timeout for this request since it might be timing out
        const response = await api.newsdesk.getExtraContacts({ timeout: 30000 })
        employees = response.data?.map((ndUser) => ({ value: ndUser.id, label: ndUser.name.trim(), emp: ndUser })) ?? []
      } catch (error) {
        console.error('loadEmployees(): could not load extra contacts', error)
        // Continue with the function even if this request fails
      }

      try {
        const response = await api.newsdesk.getNewsDeskUsers()
        const empData = response.data?.map((emp) => ({ value: emp.id, label: emp.name.trim(), emp })) ?? []
        employees = employees.concat(empData)
      } catch (error) {
        console.error('loadEmployees(): could not employees data', error)
      }

      // Commit any employees we did successfully load
      if (employees.length > 0) {
        commit('LOAD_OPTION_TYPE', { type: 'employees', data: employees })
      }
    },

    async addExtraContact({ commit, state, dispatch }, { name, email }) {
      const _s = await api.newsdesk.addExtraContact({ name, email })
      const contact = _s.data
      commit('UPSERT_EMPLOYEE', { value: contact.id, label: contact.name.trim(), emp: contact })
    },

    async updateExtraContact({ commit, state, dispatch }, { id, name, email, newStation }) {
      const _s = await api.newsdesk.saveExtraContact({ id, name, email, newStation })
      const contact = _s.data
      commit('UPSERT_EMPLOYEE', { value: contact.id, label: contact.name.trim(), emp: contact })
    },

    async deleteExtraContact({ commit, state, dispatch }, id) {
      await api.newsdesk.deleteExtraContact(id)
      commit('DELETE_EMPLOYEE', id)
    },

    async addOptionType({ commit, state, dispatch }, { type, data, station, skipCache = true }) {
      const _s = await api.newsdesk.saveColumnOption(type, data, station)
      await dispatch('loadOptionType', { type, skipCache })
    },

    async updateOptionType({ commit, state, dispatch }, { type, data, station, skipCache = true }) {
      const _s = await api.newsdesk.saveColumnOption(type, data, station)
      await dispatch('loadOptionType', { type, skipCache })
    },

    async deleteOptionType({ commit, state, dispatch }, { type, id, station, skipCache = true }) {
      await api.newsdesk.deleteColumnOption(type, id, station)
      await dispatch('loadOptionType', { type, skipCache })
    },
    async loadNotificationGroupsList({ commit, state, dispatch }) {
      // get list of stories from API
      const _o = await api.newsdesk.getNotificationGroupsList()
      let requests = _o?.data ?? []

      commit('LOAD_OPTION_TYPE', { type: 'notificationGroupsList', data: requests })
    },
  },
  getters: {
    storyTags(state) {
      return state.storyTags
    },
    videoTags(state) {
      return state.videoTags
    },
    storyType(state) {
      return state.storyType
    },
    employees(state) {
      return state.employees
    },
    format(state) {
      return state.format
    },
    platforms(state) {
      return state.platforms
    },
    region(state) {
      return state.region
    },
    status(state) {
      return state.status
    },
    pillar(state) {
      return state.pillar
    },
    storyApproved(state) {
      return state.storyApproved
    },
    liveType(state) {
      return state.liveType
    },
    liveSource(state) {
      return state.liveSource
    },
    notificationGroupsList(state) {
      return state.notificationGroupsList
    }
  }
}
